/**
 * The icons a landing page author can choose, stored by name on the page.
 */
import {
  Activity, AlertTriangle, BarChart3, BookOpen, BookText, Briefcase, Building2, Calendar, ClipboardCheck, ClipboardList,
  Cog, DollarSign, Factory, FileCheck2, FileInput, FileText, FolderOpen, GitBranch, Globe, GraduationCap, HardHat, Headphones,
  HeartPulse, Home, Inbox, Info, Laptop, LayoutDashboard, Link, ListChecks, Lock, Mail, Megaphone, MessageSquare, Package,
  Phone, Plane, Search, Send, Shield, ShieldCheck, ShoppingCart, Sparkles, Star, Table2, Truck, Type, Users, Wrench,
  type LucideIcon,
} from 'lucide-react'

export const LANDING_ICONS: Record<string, LucideIcon> = {
  'home': Home,
  'send': Send,
  'inbox': Inbox,
  'clipboard-check': ClipboardCheck,
  'clipboard-list': ClipboardList,
  'file-input': FileInput,
  'file-text': FileText,
  'file-check': FileCheck2,
  'folder': FolderOpen,
  'book': BookOpen,
  'book-text': BookText,
  'list-checks': ListChecks,
  'git-branch': GitBranch,
  'activity': Activity,
  'dashboard': LayoutDashboard,
  'bar-chart': BarChart3,
  'table': Table2,
  'search': Search,
  'users': Users,
  'building': Building2,
  'factory': Factory,
  'hard-hat': HardHat,
  'wrench': Wrench,
  'cog': Cog,
  'package': Package,
  'truck': Truck,
  'shopping-cart': ShoppingCart,
  'dollar': DollarSign,
  'briefcase': Briefcase,
  'calendar': Calendar,
  'graduation-cap': GraduationCap,
  'shield': Shield,
  'shield-check': ShieldCheck,
  'lock': Lock,
  'alert': AlertTriangle,
  'heart-pulse': HeartPulse,
  'laptop': Laptop,
  'headphones': Headphones,
  'phone': Phone,
  'mail': Mail,
  'message': MessageSquare,
  'megaphone': Megaphone,
  'plane': Plane,
  'globe': Globe,
  'link': Link,
  'info': Info,
  'star': Star,
  'sparkles': Sparkles,
  'type': Type,
}

export const LANDING_ICON_NAMES = Object.keys(LANDING_ICONS)
